/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolrefine3Inputs */

const en_medialibrarytoolrefine3 = /** @type {(inputs: Medialibrarytoolrefine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refine`)
};

const de_medialibrarytoolrefine3 = /** @type {(inputs: Medialibrarytoolrefine3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfeinert`)
};

/**
* | output |
* | --- |
* | "Refine" |
*
* @param {Medialibrarytoolrefine3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolrefine3 = /** @type {((inputs?: Medialibrarytoolrefine3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolrefine3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolrefine3(inputs)
	return de_medialibrarytoolrefine3(inputs)
});
export { medialibrarytoolrefine3 as "mediaLibraryToolRefine" }